import * as React from 'react';
import cn from 'classnames';
import { useMediaQuery } from 'react-responsive';
import { Dialog } from '@mui/material';
import { useTheme } from '../../../theme';
import { MOBILE_MIN_WIDTH } from '../../../utils';
import { GrowTransition, SlideUpTransition } from '../Transitions';
import { useSwipeDown } from '../hooks';
import CloseButton from '../../../BaseComponents/Button/components/CloseButton/CloseButton';
import { useBlurActiveElement } from '../../../hooks';
const ModalX = ({ size = 'small', classes, children, isOpen = false, onClose, scroll = 'paper', title, footer, ignoreClose, noPadding, keepMounted = true, enableSwipeToClose = true, paperProps }) => {
    const theme = useTheme('BaseComponents').ModalX;
    const isMobile = useMediaQuery({ maxWidth: MOBILE_MIN_WIDTH });
    /**
     * WEBSKY-5566:
     * Перед закрытием модалки/диалогового окна, снимаем фокус с активного элемента (если есть),
     * чтобы избежать ошибки "blocked aria-hidden".
     */
    useBlurActiveElement(isOpen);
    const { handlers, contentRef, swipeBlockRef, swipeFxRef, paperRef } = useSwipeDown({
        scroll,
        onClose,
        isMobile,
        isOpen,
        enableSwipeToClose
    });
    const isFullscreen = size === 'fullscreen';
    const showCloseButton = Boolean(onClose && !ignoreClose);
    const isSwipeEnabled = Boolean(enableSwipeToClose && isMobile && onClose);
    const showSwipeBlock = isSwipeEnabled && !isFullscreen;
    /* Закрытие по свайпу добавляем на все диалоговое окно */
    const dialogHandlers = scroll === 'paper' && isSwipeEnabled ? Object.assign({}, handlers) : null;
    /* Закрытие по свайпу добавляем только на ручку-свайп */
    const swipeBlockHandlers = scroll === 'body' && isSwipeEnabled ? Object.assign({}, handlers) : null;
    return (React.createElement(Dialog, Object.assign({}, dialogHandlers, { open: isOpen, onClose: showCloseButton ? onClose : undefined, keepMounted: keepMounted, closeAfterTransition: false, disableEnforceFocus: isFullscreen, fullScreen: isFullscreen, scroll: scroll, fullWidth: true, classes: {
            root: cn(theme.root, classes === null || classes === void 0 ? void 0 : classes.root),
            container: cn(theme.dialog_container, classes === null || classes === void 0 ? void 0 : classes.dialog_container),
            paper: cn(theme.paper, theme[size], classes === null || classes === void 0 ? void 0 : classes.paper, {
                [theme.paper__fullScreen]: isFullscreen,
                [theme.paper__noPadding]: noPadding
            }),
            paperScrollBody: theme.paper_paperScrollBody
        }, TransitionComponent: isMobile || isFullscreen ? SlideUpTransition : GrowTransition, PaperProps: Object.assign({ ref: paperRef }, paperProps) }),
        showSwipeBlock && (React.createElement("div", Object.assign({ ref: swipeBlockRef, className: cn(theme.swipeBlock, classes === null || classes === void 0 ? void 0 : classes.swipeBlock) }, swipeBlockHandlers),
            React.createElement("div", { className: theme.swipeBlock_line, ref: swipeFxRef }))),
        showCloseButton && (React.createElement(CloseButton, { onClick: onClose, variant: "closePopup", classes: { root: cn(theme.closeButton, classes === null || classes === void 0 ? void 0 : classes.closeButton) } })),
        React.createElement("div", { className: cn(theme.top_wrapper, classes === null || classes === void 0 ? void 0 : classes.top_wrapper), onMouseDown: e => e.stopPropagation() },
            title,
            React.createElement("div", { className: cn(theme.content, classes === null || classes === void 0 ? void 0 : classes.content), ref: contentRef }, children)),
        footer));
};
export default ModalX;
